import React from 'react';
import happyFlatfyPicture from './assets/happy-flatfy.svg';
import styles from './SucessForm.module.scss';

const SuccessForm = () => (
  <div className={styles.root}>
    <div>
      <p className={styles.container}>
        Thank you!
        <br />
        Your message has been
        <br />
        sent successfully
      </p>
      <img src={happyFlatfyPicture} alt="Happy Flatfy logo" />
    </div>
  </div>
);

export default SuccessForm;
